import OnboardCardLayout from '../components/OnboardCardLayout';
import { useEffect, useState } from 'react';
import { getTermsAndConditionsURL, getQueryData, withCredentials, updateOnboardingStatusURL, instance as axiosInstance } from '../../../services';
import { useMutation, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import TranslationMessage from './transMessage';
import { useAppContext, useSnackbar } from '../../../contexts';
import { BackdropComponent } from '../../../components';
import { validateErrorMsg } from '../../../utils/error.utils';

export const TermsAndConditions = () => {
    const { t } = useTranslation();
    const { showSnackbar } = useSnackbar();
    const tempData = require('../../../assets/data/onboardData.json')
    const [data, setData] = useState(tempData?.data)
    const [isTermsLoading, setIsTermsLoading] = useState(false)

    const { providerId, userData, fetchProvider } = useAppContext()

    const { data: termsData } = useQuery("termsAndConditions", async () =>
        getQueryData(getTermsAndConditionsURL, withCredentials()),
        { enabled: false }
    );

    useEffect(() => {
        if (termsData?.data?.data) {
            setData(termsData)
        }
    }, [termsData])

    const termsMutation = useMutation((params: any) => {
        setIsTermsLoading(true)
        return axiosInstance().put(updateOnboardingStatusURL(providerId), params, withCredentials())
    },
        {
            onSuccess: () => {
                fetchProvider()
            },
            onError: (error: any) => {
                showSnackbar(validateErrorMsg(error?.data?.detail),"error")
            },
            onSettled: () => {
                setIsTermsLoading(false)
            }
        }
    );

    const onNextClick = (checked: boolean) => {
        if (!checked) {
            showSnackbar("Please accept Terms of Use.","error")
            return
        }
        if (userData) {
            const termsParams = {
                ...userData,
                appOnBoardings: userData?.appOnBoardings.map((step: any) =>
                    step.type === "TermsCondition" ? { ...step, isDone: true } : step
                )
            }
            termsMutation.mutate(termsParams)
        }
        else {
            showSnackbar("Something went wrong!","error")
        }
    }

    return (
        <>
            <OnboardCardLayout
                pageTitle={t(TranslationMessage.PAGE_TC_TITLE)}
                pageDescription={t(TranslationMessage.TERMS_DESCRIPTION)}
                checkboxContent={t(TranslationMessage.TC_CHECKBOX_LABEL)}
                content={data}
                onClickNext={onNextClick}
                mode='terms'
            />
            <BackdropComponent showBackdrop={isTermsLoading} />
        </>
    );
}